<layout>
  <div class="contactImage">
    <div class="textForContact">
      <h2 class="outline" >{{config?.mobileAppHeading}}</h2>
      <p class="outline">{{config?.mobileAppBody}}</p>
      <h4 class="outline">{{config?.coming}}</h4>
      <div class="row" style="margin: 20px">
      </div>
    </div>
  </div>
</layout>